import { init } from '@sentry/browser';
import { environment } from '@/constants';
import { Vue as VueIntegration } from '@sentry/integrations';

export default {
  // Ensures this is the first initializer to load so that we have early error
  // reporting.
  index: 0,

  handler(Vue) {
    const debug = environment !== 'production';
    init({
      dsn: 'https://8a8296d6deed410d9e252ddc8aad735e@o411790.ingest.sentry.io/5287514',
      environment,
      debug,
      integrations: [new VueIntegration({ Vue, logErrors: debug })],
    });
  },
};
